// extracted by mini-css-extract-plugin
export var borderRadius = "_9e-4";
export var large = "_9e-3";
export var logoContainer = "_9e-0";
export var nameLogo = "_9e-2";
export var small = "_9e-1";